import { useEffect, useState } from "react";
import { useAdvanceSearchContext } from "../AdvanceSearchContext";
import Select from "../../../../components/Select";
import { JobRoleDetailService } from "../../../../services/JobRoleDetailService";

export default function BusinessAreaInterest() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  const [candidateInterestBusinessAreas, setCandidateInterestBusinessAreas] = useState([]);

  useEffect(() => {
    JobRoleDetailService.getAllBusinessAreas().then((data) => {
      setCandidateInterestBusinessAreas(data);
      });
  }, []);
  
  return (
    <fieldset>
        <legend>{t("Business Area Interest")}</legend>
        <Select
          className="form-select fontsize-legend"
          name="candidateInterestBusinessAreaId"
          id="candidateInterestBusinessAreaId"
          onChange={onChange}
          value={searchObject.candidateInterestBusinessAreaId || ""}
        >
          <option></option>
          {candidateInterestBusinessAreas.map((candidateInterestBusinessArea) => (
            <option className="fontsize-legend" key={candidateInterestBusinessArea.id} value={candidateInterestBusinessArea.id}>
              {t(candidateInterestBusinessArea.description)}
            </option>
          ))}
        </Select>
    </fieldset>
  );
}
